<template>
<div class="gantt-index" ref="gantt-index" v-loading="loading">
  <TableList :autoKey="false" ref="table" :projectId="projectId" @dataChange="dataChange" @loading="loadingEnt" @addTaskList="addTaskList">
  </TableList>
  <Gantt :dataset="dataset" v-if="(dataset.unArch.length > 0 || dataset.arch.length > 0) && !loading"></Gantt>
</div>
</template>
<script>
import TableList from '../tableNew'
import Gantt from './main'
import bus from '@/bus'
export default {
  props: {
    projectId: [String, Number]
  },
  components: {
    TableList,
    Gantt
  },
  data() {
    return {
      dataset: {
        unArchClose: false,
        archClose: false,
        unArch:[],
        arch: []
      },
      loading: true,
      timer: null
    }
  },
  mounted() {
      this.windowAddMouseWheel()
  },
  methods:{
    loadingEnt(loading) {
      this.loading = loading
    },
    dataChange() {
      this.debounce(() => {
        this.dataset = this.$refs.table.taskList || []
      }, 300)
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    windowAddMouseWheel() {
      var scrollFunc = (e) => {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        let value = ''
        let n = -1
        if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
          value = e.wheelDelta
          value > 0 ? n = -1 : n = 1
        } else if (e.detail) {  //Firefox滑轮事件
          value = e.detail
          value > 0 ? n = 1 : n = -1
        }
        let seep = 2
        let timer = setInterval(() => {
          if (seep >= 14) {
            clearInterval(timer)
            return
          }
          bus.$emit('changeTableScroll', seep * n)
          seep = seep + 2
        }, 20)
      }
      //给页面绑定滑轮滚动事件
      let ele = this.$refs['gantt-index']
      if (ele) {
        ele.addEventListener('DOMMouseScroll', scrollFunc, false);
        //滚动滑轮触发scrollFunc方法
        ele.onmousewheel = scrollFunc;
      }
    },
    addTaskList() {
      console.log(666)
      this.$emit('addTaskList')
    },
    addSuccess(task_list_id, id, pid) {
      if(pid) {
        this.$refs.table.updateTask({task_id: pid, task_list_id})
      } else {
        this.$refs.table.restData()
      }
    },
    restData() {
      this.$refs.table.restData();
    }
  }
}
</script>
<style lang="scss">
.gantt-index{
  display: flex;
  height: 100%;
  width: 100%;
  // justify-content: center;
  align-items: center;
  .nothing-box {
    position: fixed;
  }
  .table-fixed-box .outer-box{
    overflow: hidden;
  }
  .task-name-in , .table-line---item{
    border-right: 0 none !important;
  }
  .table-right-line {
    height: 50px;
    background-color: #fff;
  }
  .table-right-line::after {
    background-color: transparent !important;
  }
  .fo-header-in {
    border-right: 0 none !important;
  }
}
</style>
